const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Backend project routes are guarded by ParseUUIDPipe / ProjectAccessGuard.
 * Use this before firing a request built from a URL segment so reserved words
 * like "overview" never reach `/projects/:id` and return 400.
 */
export const isUuid = (value) => typeof value === 'string' && UUID_PATTERN.test(value.trim());
